<template>
  <v-app-bar
    fixed
    :height="headerHeight"
    app
    color="transparent"
    class="flex-column flex-wrap align-start justify-start px-2 px-sm-6"
  >
    <!-- <v-expand-x-transition>
      <div v-show="!$store.state.drawer" class="ml-n2 mr-4">
        <v-sheet :height="headerHeight" :width="headerHeight" class="d-flex align-center justify-center"
          color="transparent">
          <img width="36" height="36" class="ml-2" contain
            :src="require($store.state.darkMode ? '../../assets/logo-dark.svg' : '../../assets/logo-light.svg')" />
        </v-sheet>
      </div>
    </v-expand-x-transition> -->

    <v-app-bar-nav-icon
      @click="$store.state.drawer = !$store.state.drawer"
      class="rounded-xl ml-0"
    />

    <v-btn
      icon
      tile
      @click="$store.commit('openSearch')"
      class="rounded-xl">
      <v-icon>mdi-magnify</v-icon>
    </v-btn>

    <v-spacer />

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          height="48"
          class="mx-1 rounded-xl"
          :color="statusIndicatorColor"
          v-bind="attrs"
          v-on="on"
          :to="{ name: 'Services' }"
        >
          <!-- <span class="d-sm-inline-block d-none">Státusz</span> -->
          <template v-if="services.running !== services.all && services.running !== 0">
            <v-icon :color="statusIndicatorColor">mdi-alert-circle</v-icon>
          </template>
          <template v-else>
            <v-icon color="success">mdi-check-circle</v-icon>
          </template>
        </v-btn>
      </template>
      <span> {{ statusIndicatorTitle }} </span>
    </v-tooltip>

    <v-menu transition="slide-y-transition" bottom :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          text
          small
          height="48"
          class="ml-2 px-2 rounded-xl"
          v-bind="attrs"
          v-on="on">
          <v-avatar color="primary" size="34" class="rounded-lg">
            <v-icon size="24" color="white">mdi-account</v-icon>
          </v-avatar>
          <div class="data text-left mx-2">
            <div class="font-weight-bold text-subtitle-2" style="text-transform: none">
              {{ $store.state.user.name }}
            </div>
            <div class="text-caption">{{ $store.state.user.email }}</div>
          </div>
          <v-icon size="24">mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-sheet class="d-flex pa-4">
          <v-avatar color="primary" size="64" class="rounded-xl">
            <v-icon size="48" color="white">mdi-account</v-icon>
          </v-avatar>

          <div class="d-flex flex-column justify-center pa-2 ml-2">
            <div class="font-weight-bold">
              {{ $store.state.user.name }}
            </div>
            <div>
              {{ $store.state.user.email }}
            </div>
          </div>
        </v-sheet>

        <div class="d-flex flex-column justify-center pa-4">
          <v-btn
            text
            small
            block
            to="/change-password"
            height="36"
            class="px-3 mb-1 rounded-xl">
            <v-icon left>mdi-key-variant</v-icon>
            Jelszó módosítás
          </v-btn>

          <v-btn
            text
            small
            block
            height="36"
            class="px-3 mb-1 rounded-xl"
            @click="$store.commit('toggleDarkMode')"
          >
            <template v-if="$vuetify.theme.dark">
              <v-icon left>mdi-white-balance-sunny</v-icon>
              Váltás világos módra
            </template>
            <template v-else>
              <v-icon left>mdi-weather-night</v-icon>
              Váltás sötét módra
            </template>
          </v-btn>
        </div>

        <v-sheet color="primary" height="2" />

        <v-sheet class="pa-4">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="green darken-2"
                depressed
                block
                dark
                @click="$logout"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon left>mdi-exit-run</v-icon>
                Exit
              </v-btn>
            </template>
            <span>Kijelentkezés</span>
          </v-tooltip>
        </v-sheet>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  data: () => ({
    statusInterval: null,
    unreachable_gates: false,
    daemon_unreachable: false,
    uniomd_unreachable: false,
    services: {
      running: 0,
      all: 0,
    },
  }),

  mounted() {
    // if (process.env.NODE_ENV === 'development') {
    //   return;
    // }

    clearInterval(this.statusInterval);
    this.checkServiceStatus();
    this.statusInterval = setInterval(() => {
      this.checkServiceStatus();
    }, 60000);
  },

  computed: {
    headerHeight() {
      return parseInt(process.env.VUE_APP_HEADER_HEIGHT);
    },

    statusIndicatorColor() {
      if (this.services.running === this.services.all) {
        return 'success';
      }
      if (this.services.running === 0) {
        return 'error';
      }
      return 'warning';
    },
    statusIndicatorTitle() {
      if (this.services.running === this.services.all) {
        return 'A szolgáltatások futnak';
      }
      if (this.services.running === 0) {
        return 'A szolgáltatások nem futnak';
      }

      return `${this.services.running} szolgáltatás fut ${this.services.all} szolgáltatásból`;
    },
  },

  methods: {
    async checkServiceStatus() {
      const response = await this.$http.get('services/status');
      this.services = response.services;
    },

    // async checkCheckerLog() {
    //   const response = await this.$http.get('check_checkerlog');
    //   this.unreachable_gates = response.unreachable_gates;
    //   this.daemon_unreachable = response.daemon_unreachable;
    //   this.uniomd_unreachable = response.uniomd_unreachable;
    // },
  },

  destroyed() {
    clearInterval(this.statusInterval);
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-toolbar__content {
  padding: 0 !important;
}

.v-application header.white {
  width: auto;
  border-bottom-width: 4px;
  border-bottom-style: solid;
  border-color: var(--v-secondary-base) !important;
}

#profile-button .data > div {
  line-height: 14px;
}

#server-status-success {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
    transform: scale(1);
  }

  75% {
    opacity: 0.75;
    transform: scale(0.9);
  }
}
</style>
